import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewEncapsulation, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import 'jquery/dist/jquery.min.js';
import SlotMachine from 'jquery-slotmachine/lib/slot-machine.js';
import { CookieService } from 'ngx-cookie-service';
import { $ } from 'protractor';
import * as localforage from 'localforage';

declare var document;
@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  encapsulation: ViewEncapsulation.ShadowDom,
  styleUrls: ['./game.component.scss']
})
export class GameComponent implements OnInit, AfterViewInit {
  public spin:boolean = false;
  public data:any
  @Output() public result: EventEmitter<any> = new EventEmitter;
  @ViewChild('casinoShuffle',{static: false}) casinoShuffle: ElementRef;
  @ViewChild('casinoStop',{static: false}) casinoStop: ElementRef;

  @ViewChild('casino1',{static: false}) casino1: ElementRef;
  @ViewChild('casino2',{static: false}) casino2: ElementRef;
  @ViewChild('casino3',{static: false}) casino3: ElementRef;
  @ViewChild('text1',{static: false}) text1: ElementRef;
  @ViewChild('casino',{static: false}) casino: ElementRef;
  @ViewChild('animation1',{static: false}) animation1: ElementRef;
  @ViewChild('animation2',{static: false}) animation2: ElementRef;
  @ViewChild('animation3',{static: false}) animation3: ElementRef;
  @ViewChild('slot1',{static: false}) slot1: ElementRef;
  @ViewChild('slot2',{static: false}) slot2: ElementRef;
  @ViewChild('slot3',{static: false}) slot3: ElementRef;

  ngAfterViewInit(): void {
    const btnShuffle = this.casinoShuffle.nativeElement;
    const casino = this.casino.nativeElement;
    const casino1 = this.casino1.nativeElement;
    const casino2 = this.casino2.nativeElement;
    const casino3 = this.casino3.nativeElement;

    /*const game_data: boolean = this.cookieService.check('game-history');
    if(!game_data){
      console.log("NO exists")
      let data = {
        hora_inicio:"18:00",
        horasJuego:5,
        cubrebocas:{
          n:30,
          win:[],
        },
        desc10:{
          n:40,
          win:[],
        },
        desc15:{
          n:40,
          win:[],
        },
      }
      this.cookieService.set( 'game-history',JSON.stringify(data));
    }*/

    localforage.getItem('game-history').then((value:string)=> {
      var data
      console.log(value)
      if(!value){
        console.log("NO exists")
          data = {
          hora_inicio:"13:00",
          horasJuego:5,
          cubrebocas:{
            n:30,
            win:[],
          },
          desc10:{
            n:40,
            win:[],
          },
          desc15:{
            n:40,
            win:[],
          },
        }
        localforage.setItem('game-history', JSON.stringify(data)).then((value) => {
          // Do other things once the value has been saved.
          console.log(JSON.parse(value));
          this.data = JSON.parse(value)
        }).catch(function(err) {
            // This code runs if there were any errors
            console.log(err);
        });
        // This code runs once the value has been loaded
        // from the offline store.
        console.log(value);
      }else{
        data = JSON.parse(value)
        console.log(data);
      }
      casino.style.display = 'block'

    var date = new Date()
    var hour = date.getHours();
    var minutes = date.getMinutes();
    var day = date.getDate()
    var month = date.getMonth()
    month = month + 1 
    var year = date.getFullYear()
    var str_day = day+""
    var str_month = month+""
    if(day<10){
      str_day = '0'+day
    }
    if(month<10){
      str_month = '0'+month
    }



    console.log(data)

    var hour_start = data.hora_inicio.split(":")
    var start_hour = parseInt(hour_start[0])
    if(hour<start_hour){
      this.lose(casino1,casino2,casino3,btnShuffle)
      return
    }
    console.log(start_hour)
    console.log(hour)

    var cubrebocas_number_winners_today = 0
    var desc10_number_winners_today = 0
    var desc15_number_winners_today = 0
    
    var found_cubrebocas_todayDate = false
    var found_10desc_todayDate = false
    var found_15desc_todayDate = false


    if(data.cubrebocas.win.length != 0){
      console.log(year+"-"+str_month+"-"+str_day)
      for(let win of data.cubrebocas.win){
        if(win.date == year+"-"+str_month+"-"+str_day){
          found_cubrebocas_todayDate = true
          if(win.w.length>0){
            cubrebocas_number_winners_today = win.w.length
          }
        }
      }
    }else{
      found_cubrebocas_todayDate = true
      console.log(year+"-"+str_month+"-"+str_day)
      data.cubrebocas.win.push({
        date:year+"-"+str_month+"-"+str_day,
        w:[]
      })
    }
    if(data.desc10.win.length != 0){
      console.log(year+"-"+str_month+"-"+str_day)
      for(let win of data.desc10.win){
        if(win.date == year+"-"+str_month+"-"+str_day){
          found_10desc_todayDate = true
          if(win.w.length>0){
            desc10_number_winners_today = win.w.length
          }
        }
      }
    }else{
      found_10desc_todayDate = true
      console.log(year+"-"+str_month+"-"+str_day)
      data.desc10.win.push({
        date:year+"-"+str_month+"-"+str_day,
        w:[]
      })
    }
    if(data.desc15.win.length != 0){
      console.log(year+"-"+str_month+"-"+str_day)
      for(let win of data.desc15.win){
        if(win.date == year+"-"+str_month+"-"+str_day){
          found_15desc_todayDate = true
          if(win.w.length>0){
            desc15_number_winners_today = win.w.length
          }
        }
      }
    }else{
      found_15desc_todayDate = true
      console.log(year+"-"+str_month+"-"+str_day)
      data.desc15.win.push({
        date:year+"-"+str_month+"-"+str_day,
        w:[]
      })
    }

    if(!found_cubrebocas_todayDate){
      console.log(year+"-"+str_month+"-"+str_day)
      data.cubrebocas.win.push({
        date:year+"-"+str_month+"-"+str_day,
        w:[]
      })
    }

    if(!found_10desc_todayDate){
      console.log(year+"-"+str_month+"-"+str_day)
      data.desc10.win.push({
        date:year+"-"+str_month+"-"+str_day,
        w:[]
      })
    }

    if(!found_15desc_todayDate){
      console.log(year+"-"+str_month+"-"+str_day)
      data.desc15.win.push({
        date:year+"-"+str_month+"-"+str_day,
        w:[]
      })
    }
    localforage.setItem('game-history', JSON.stringify(data)).then((value)=> {
      // Do other things once the value has been saved.
      console.log(JSON.parse(value));
      this.data = JSON.parse(value)
    }).catch(function(err) {
        // This code runs if there were any errors
        console.log(err);
    });

    if(cubrebocas_number_winners_today == 0 && desc10_number_winners_today == 0 && desc15_number_winners_today == 0){
      var index = Math.floor(Math.random() * 3); 
      var iswinner = Math.floor(Math.random() * 2); 
      console.log("ejecutar winner"+iswinner)
      if(iswinner == 1){
        this.win(casino1,casino2,casino3,btnShuffle,index)
      }else{
        this.lose(casino1,casino2,casino3,btnShuffle)
      }
      return
    }
    
    console.log("win_cubre:"+cubrebocas_number_winners_today)
    console.log("win_desc10:"+desc10_number_winners_today)
    console.log("win_desc15:"+desc15_number_winners_today)

    var cubrebocas_winners_by_hour = Math.floor(data.cubrebocas.n / data.horasJuego)
    var desc10_winners_by_hour = Math.floor(data.desc10.n / data.horasJuego)
    var desc15_winners_by_hour = Math.floor(data.desc15.n / data.horasJuego)  

    console.log(cubrebocas_winners_by_hour)
    console.log(desc10_winners_by_hour)
    console.log(desc15_winners_by_hour)

    var last_hour = false
    if(hour>=((start_hour+data.horasJuego)-1)){
      last_hour = true
    }
 
    if(last_hour){
      console.log("isLast")
      let last_minutes = false 
      let current_hour = hour - start_hour + 1 
      let should_winners_cubrebocas = data.cubrebocas.n
      let should_winners_desc10 = data.desc10.n
      let should_winners_desc15 = data.desc15.n 

      console.log("should_winners_cubrebocas:: "+should_winners_cubrebocas)
      console.log("should_winners_desc10:: "+should_winners_desc10)
      console.log("should_winners_desc15:: "+should_winners_desc15)
      console.log("Minutos:"+minutes)
      if(minutes>49){
        console.log("Minutos magicos :)")
        last_minutes = true 
      }

      let rifar_cubrebocas = false
      let rifar_desc10 = false
      let rifar_desc15 = false

      if(cubrebocas_number_winners_today<should_winners_cubrebocas){
        rifar_cubrebocas = true
      }
      if(desc10_number_winners_today<should_winners_desc10){
        rifar_desc10 = true
      }
      if(desc15_number_winners_today<should_winners_desc15){
        rifar_desc15 = true
      }

      if(rifar_cubrebocas && rifar_desc10 && rifar_desc15){
        let index = Math.floor(Math.random() * 3); 
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc10 && rifar_desc15){
        let index = Math.floor(Math.random() * 2); 
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc10 && rifar_cubrebocas){
        let index = Math.floor(Math.random() * 2); 
        if(index == 1) index = 2;
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc15 && rifar_cubrebocas){
        let index = Math.floor(Math.random() * 2); 
        index = index + 1
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc10){
        let index = 0
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc15){
        let index = 1
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_cubrebocas){
        let index = 2
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }

      this.lose(casino1,casino2,casino3,btnShuffle)

    }else{
      let last_minutes = false 
      let current_hour = hour - start_hour + 1 
      let should_winners_cubrebocas = Math.floor(current_hour*cubrebocas_winners_by_hour)
      let should_winners_desc10 = Math.floor(current_hour*desc10_winners_by_hour)
      let should_winners_desc15 = Math.floor(current_hour*desc15_winners_by_hour)

      console.log("should_winners_cubrebocas:: "+should_winners_cubrebocas)
      console.log("should_winners_desc10:: "+should_winners_desc10)
      console.log("should_winners_desc15:: "+should_winners_desc15)
      console.log("Minutos:"+minutes)
      if(minutes>49){
        console.log("Minutos magicos :)")
        last_minutes = true 
      }

      let rifar_cubrebocas = false
      let rifar_desc10 = false
      let rifar_desc15 = false

      if(cubrebocas_number_winners_today<should_winners_cubrebocas){
        rifar_cubrebocas = true
      }
      if(desc10_number_winners_today<should_winners_desc10){
        rifar_desc10 = true
      }
      if(desc15_number_winners_today<should_winners_desc15){
        rifar_desc15 = true
      }

      if(rifar_cubrebocas && rifar_desc10 && rifar_desc15){
        let index = Math.floor(Math.random() * 3); 
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc10 && rifar_desc15){
        let index = Math.floor(Math.random() * 2); 
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc10 && rifar_cubrebocas){
        let index = Math.floor(Math.random() * 2); 
        if(index == 1) index = 2;
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc15 && rifar_cubrebocas){
        let index = Math.floor(Math.random() * 2); 
        index = index + 1
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc10){
        let index = 0
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_desc15){
        let index = 1
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }
      if(rifar_cubrebocas){
        let index = 2
        let iswinner = Math.floor(Math.random() * 2); 
        console.log("ejecutar winner"+iswinner)
        if(iswinner == 1){
          this.win(casino1,casino2,casino3,btnShuffle,index)
        }else{
          if(last_minutes){
            this.win(casino1,casino2,casino3,btnShuffle,index)
            return
          }else{
            this.lose(casino1,casino2,casino3,btnShuffle)
            return
          }
        }
        return
      }

      this.lose(casino1,casino2,casino3,btnShuffle)

    }

    //this.win(casino1,casino2,casino3,btnShuffle,0)
    //this.win(casino1,casino2,casino3,btnShuffle,1)
    
    //this.lose(casino1,casino2,casino3,btnShuffle)
    //this.win(casino1,casino2,casino3,btnShuffle,2)
  }).catch(function(err) {
      // This code runs if there were any errors
      console.log(err);
  });
  }
  
  win(casino1,casino2,casino3,btnShuffle,index_win){
    const mCasino1 = new SlotMachine(casino1, {
      active: 0,
      delay: 500,
      direction:"down",
      randomize() {
        return index_win;
      }
    });
    const mCasino2 = new SlotMachine(casino2, {
      active: 1,
      delay: 500,
      direction:"down",
      randomize() {
        return index_win;
      }
    });
    const mCasino3 = new SlotMachine(casino3, {
      active: 2,
      delay: 500,
      direction:"down",
      randomize() {
        return index_win;
      }
    });  

    btnShuffle.addEventListener('click', () => {
      localforage.getItem('game-history').then((value:string)=> {
        const animation1 = this.animation1.nativeElement;
        const animation2 = this.animation2.nativeElement;
        const animation3 = this.animation3.nativeElement;
        const slot1 = this.slot1.nativeElement;
        const slot2 = this.slot2.nativeElement;
        const slot3 = this.slot3.nativeElement;
        const text1 = this.text1.nativeElement;
        btnShuffle.style.display = 'none'
        text1.style.display = 'none'
        animation1.style.opacity = 1
        animation2.style.opacity = 1
        animation3.style.opacity = 1
        var slots = ['slot1-img','slot2-img','slot3-img']
        slot1.classList.remove(slots[0])
        slot2.classList.remove(slots[1])
        slot3.classList.remove(slots[2])
        slot1.classList.add(slots[index_win])
        slot2.classList.add(slots[index_win])
        slot3.classList.add(slots[index_win])
        if(this.spin)return;
        this.spin = true
        console.log("click")
        mCasino1.shuffle(9999);
        mCasino2.shuffle(9999);
        mCasino3.shuffle(9999);
        setTimeout(()=>{
          animation1.style.opacity = 0
          mCasino1.stop();
        },5000)
        setTimeout(()=>{
          animation2.style.opacity = 0
          mCasino2.stop();
        },6000)
        setTimeout(()=>{
          animation3.style.opacity = 0
          mCasino3.stop();
          this.spin=false
        },7000)
        setTimeout(()=>{
          this.result.emit(index_win);
        },10000)
        console.log(JSON.parse(value))
        let data = JSON.parse(value)
        var date = new Date()
        var day = date.getDate()
        var month = date.getMonth()
        month = month + 1 
        var year = date.getFullYear()
  
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var str_day = day+""
        var str_month = month+""
        if(day<10){
          str_day = '0'+day
        }
        if(month<10){
          str_month = '0'+month
        }
        var str_minutes
        var str_hour
        if(minutes<10){
          str_minutes = '0'+minutes
        }else{
          str_minutes = ''+minutes
        }
        if(hour<10){
          str_hour = '0'+hour
        }else{
          str_hour = ''+hour
        }
        if(index_win == 2){
          for(let win of data.cubrebocas.win){
            if(win.date == year+"-"+str_month+"-"+str_day){
              win.w.push(
                str_hour+':'+str_minutes,
              )
            }
          }
        }else if(index_win == 0){
          for(let win of data.desc10.win){
            if(win.date == year+"-"+str_month+"-"+str_day){
              win.w.push(
                str_hour+':'+str_minutes,
              ) 
            }
          }
        }else if(index_win == 1){
          for(let win of data.desc15.win){
            if(win.date == year+"-"+str_month+"-"+str_day){
              win.w.push(
                str_hour+':'+str_minutes,
              ) 
            }
          }
        }
        localforage.setItem('game-history', JSON.stringify(data)).then( (value)=> {
          // Do other things once the value has been saved.
          console.log(JSON.parse(value));
        }).catch(function(err) {
            // This code runs if there were any errors
            console.log(err);
        });
      }).catch(function(err) {
          // This code runs if there were any errors
          console.log(err);
      });

    });
  }

  lose(casino1,casino2,casino3,btnShuffle){
    var index1 = Math.floor(Math.random() * 3); 
    console.log(index1)
    var index2 = Math.floor(Math.random() * 3);
    console.log(index2) 
    var index3 = 0
    if(index1 == 0){
      index3 = Math.floor(Math.random() * 2)+1;
    }
    console.log(index3) 
    const mCasino1 = new SlotMachine(casino1, {
      active: 0,
      delay: 500,
      direction:"down",
      randomize() {
        return index1;
      }
    });
    const mCasino2 = new SlotMachine(casino2, {
      active: 1,
      delay: 500,
      direction:"down",
      randomize() {
        return index2;
      }
    });
    const mCasino3 = new SlotMachine(casino3, {
      active: 2,
      delay: 500,
      direction:"down",
      randomize() {
        return index3;
      }
    });  

    btnShuffle.addEventListener('click', () => {
      const animation1 = this.animation1.nativeElement;
      const animation2 = this.animation2.nativeElement;
      const animation3 = this.animation3.nativeElement;
      const text1 = this.text1.nativeElement;
      btnShuffle.style.display = 'none'
      text1.style.display = 'none'
      animation1.style.opacity = 1
      animation2.style.opacity = 1
      animation3.style.opacity = 1
      const slot1 = this.slot1.nativeElement;
      const slot2 = this.slot2.nativeElement;
      const slot3 = this.slot3.nativeElement;
      var slots = ['slot1-img','slot2-img','slot3-img']
      slot1.classList.remove(slots[0])
      slot2.classList.remove(slots[1])
      slot3.classList.remove(slots[2])
      slot1.classList.add(slots[index1])
      slot2.classList.add(slots[index2])
      slot3.classList.add(slots[index3])
      if(this.spin)return;
      this.spin = true
      console.log("click")
      mCasino1.shuffle(9999);
      mCasino2.shuffle(9999);
      mCasino3.shuffle(9999);
      
      setTimeout(()=>{
        animation1.style.opacity = 0
        mCasino1.stop();
      },5000)
      setTimeout(()=>{
        animation2.style.opacity = 0
        mCasino2.stop();
      },6000)
      setTimeout(()=>{
        animation3.style.opacity = 0
        mCasino3.stop();
      },7000)
      setTimeout(()=>{
        this.result.emit(3);
        this.spin=false
      },10000)
    });
  }

  constructor(private cookieService: CookieService) { }

  ngOnInit(): void {

  }

}

